// FIX: Catch dynamic import failures and offer a safe refresh
import React from 'react';
let mounted = false;

export function mountUpdateOverlay() {
  if (mounted) return;
  mounted = true;

  function show() {
    const el = document.createElement('div');
    el.id = 'cb-update-overlay';
    el.style.position = 'fixed';
    el.style.inset = '0';
    el.style.background = 'rgba(0,0,0,0.6)';
    el.style.display = 'flex';
    el.style.alignItems = 'center';
    el.style.justifyContent = 'center';
    el.style.zIndex = '99999';

    // Create content using DOM methods instead of innerHTML to prevent XSS
    const contentDiv = document.createElement('div');
    contentDiv.style.background = '#fff';
    contentDiv.style.padding = '20px';
    contentDiv.style.borderRadius = '12px';
    contentDiv.style.maxWidth = '420px';
    contentDiv.style.textAlign = 'center';
    contentDiv.style.fontFamily = 'system-ui';

    const h3 = document.createElement('h3');
    h3.style.margin = '0 0 8px';
    h3.textContent = 'Update available';
    contentDiv.appendChild(h3);

    const p = document.createElement('p');
    p.style.margin = '0 0 16px';
    p.textContent = 'We released a new version. Click reload to update.';
    contentDiv.appendChild(p);

    const button = document.createElement('button');
    button.id = 'cb-reload';
    button.style.padding = '10px 16px';
    button.style.border = 'none';
    button.style.borderRadius = '8px';
    button.style.background = '#111';
    button.style.color = '#fff';
    button.style.cursor = 'pointer';
    button.textContent = 'Reload';
    contentDiv.appendChild(button);

    el.appendChild(contentDiv);
    document.body.appendChild(el);

    button.addEventListener('click', () => {
      // Hard reload to bypass stale HTML/Service Worker
      location.href = location.href.split('#')[0];
    });
  }

  // Catch chunk load failures & dynamic import errors
  window.addEventListener('error', (e: ErrorEvent) => {
    if ((e as any)?.message?.includes('Loading chunk') || (e as any)?.message?.includes('Failed to fetch dynamically imported module')) show();
  });
  window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
    const msg = String((e.reason && (e.reason.message || e.reason)) || '');
    if (msg.includes('Loading chunk') || msg.includes('Failed to fetch dynamically imported module')) show();
  });
}
